export const sampleRate = {
  NOT_FOUND: 'low',
  CART_PROVIDER: 'low',
  NEWSLETTER: 'medium',
}
